module.exports = __webpack_public_path__ + "static/media/turbodirect.fda40489.gif";


//////////////////
// WEBPACK FOOTER
// ./src/pages/PortfolioPage/images/turbodirect.gif
// module id = 351
// module chunks = 0